import { useState } from "react";
import { AnimatePresence } from "framer-motion";
import { Header } from "@/components/Header";
import { Meters } from "@/components/Meters";
import { DecisionCard } from "@/components/DecisionCard";
import { useLang } from "@/context/LangContext";
import { useGame } from "@/hooks/useGame";
import { MAX_TURNS, TURNS_PER_YEAR, TERM_YEARS } from "@/lib/engine";

export default function Game() {
  const { t } = useLang();
  const { card, meters, turn, deltas, choose } = useGame();
  const [dragX, setDragX] = useState(0);

  const preview = card && dragX !== 0 ? card[dragX < 0 ? "left" : "right"].effects : null;
  const year = Math.min(Math.floor(turn / TURNS_PER_YEAR) + 1, TERM_YEARS);

  return (
    <div className="max-w-md mx-auto min-h-dvh px-4 pb-4 flex flex-col" data-testid="game-screen">
      <Header>
        <div className="panel px-3 py-1 text-xs font-display font-bold whitespace-nowrap" data-testid="turn-counter">
          {t.year} {year} · {t.decision} {turn + 1}<span className="text-[var(--text-light)]/50">/{MAX_TURNS}</span>
        </div>
      </Header>
      <Meters meters={meters} preview={preview} deltas={deltas} />
      <div className="flex-1 flex items-center justify-center py-4">
        <div className="relative w-full aspect-[3/4] max-h-[520px]" data-testid="card-stack">
          <div className="decision-card absolute inset-0 card-shadow-2" />
          <div className="decision-card absolute inset-0 card-shadow-1" />
          <AnimatePresence mode="wait">
            {card ? (
              <DecisionCard key={`${card.id}-${turn}`} card={card} onChoose={choose} onDrag={setDragX} />
            ) : (
              <div className="absolute inset-0 flex items-center justify-center text-[var(--text-light)]/60" data-testid="deck-loading">{t.loading}</div>
            )}
          </AnimatePresence>
        </div>
      </div>
      <div className="text-center text-xs uppercase tracking-[0.25em] text-[var(--text-light)]/40 font-semibold" data-testid="swipe-hint">{t.swipeHint}</div>
    </div>
  );
}
